import { defineComponent as _defineComponent } from 'vue'
import { VButton } from 'ah-common-lib/src/common/components';
import { defineToastComponentProps, ToastType } from 'ah-common-lib/src/toast/toastInterfaces';
import MaterialIcon from './MaterialIcon.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastComponent',
  props: { ...defineToastComponentProps() },
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (m: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const pendingActions = ref<boolean[]>([]);

function triggerAction(index: number) {
  if (props.actions[index]) {
    pendingActions.value[index] = true;
    Promise.resolve(props.actions[index].method()).finally(() => {
      pendingActions.value[index] = false;
    });
  }
}

function close() {
  emit('close');
}

const toastTypeToIcon: Record<ToastType, string> = {
  [ToastType.success]: 'check_circle',
  [ToastType.danger]: 'error',
  [ToastType.info]: 'info',
  [ToastType.warning]: 'error',
};

return { __sfc: true,emit, props, pendingActions, triggerAction, close, toastTypeToIcon, VButton, MaterialIcon }
}

})